const BrandMixin = {
  methods: {
    getBrands(perPage = 100) {
      const url = route("public.api.brands.index", {
        per_page: perPage,
      });
      return axios.get(url);
    },
  },
};

export default BrandMixin;
